'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

exports.useWindowSize = useWindowSize;

var _react = require('react');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

function useWindowSize() {
  var _useState = (0, _react.useState)(window.innerWidth),
      _useState2 = (0, _slicedToArray3.default)(_useState, 2),
      width = _useState2[0],
      setWidth = _useState2[1];

  var _useState3 = (0, _react.useState)(window.innerHeight),
      _useState4 = (0, _slicedToArray3.default)(_useState3, 2),
      height = _useState4[0],
      setHeight = _useState4[1];

  (0, _react.useEffect)(function () {
    var handleResize = function handleResize() {
      setWidth(window.innerWidth);
      setHeight(window.innerHeight);
    };
    window.addEventListener('resize', handleResize);

    return function () {
      window.removeEventListener('resize', handleResize);
    };
  });

  return { windowWidth: width, windowHeight: height };
}